export function isRejected(status: string) {
  return status === "agency_rejected" || status === "admin_rejected";
}
